import { Tooltip } from "@mui/material";
import Icon from "../../lib/components/Icons/Icon";
import { MESSAGE_CONFIG } from "../../lib/components/Filterbar/constants";

export const renderMsgType = (msgType, src) => {
  const size = { width: 30, height: 30 };

  const config = Object.values(MESSAGE_CONFIG).find(c => Number(c.msgType) === Number(msgType) && c.source === src);

  if (!config) return null;

  return (
    <Tooltip title={config.label} arrow placement="top">
      <span>
        <Icon src={config.icon} {...size} fill={config.fill} />
      </span>
    </Tooltip>
  );
};
